export class SiemPlanModel {
    ownerAccountId;
    maxSecurityAccounts;
    dailyScannedGb;
}
//# sourceMappingURL=siem-plan.js.map